import { RiArrowLeftLine, RiArrowRightLine } from 'react-icons/ri';
import { ComponentPropsWithoutRef } from 'react';
import { range } from 'lodash';
import cx from 'classnames';
import Button from '../Button';
import styles from './Pagination.module.scss';

function getRangeAround(
  from: number,
  min: number,
  max: number,
  allowance: number,
) {
  const range = [from, from];
  let a = allowance - 1;
  let i = 0;

  while (a && i < allowance * 2) {
    const x = i % 2;
    const check = x ? range[x] < max - 1 : range[x] > min;
    if (check) {
      range[x] += x ? 1 : -1;
      a--;
    }
    i++;
  }

  return range;
}

export interface PaginationProps<T> extends ComponentPropsWithoutRef<'div'> {
  items: T[];
  numOfPages?: number;
  itemsPerPage?: number;
  currentPage?: number;
  hasMore?: boolean;
  onPageChange?: (newPage: number, pages: number) => void;
}

function Pagination<T>({
  itemsPerPage = 10,
  currentPage = 0,
  numOfPages = 5,
  onPageChange,
  hasMore,
  items,
  ...props
}: PaginationProps<T>) {
  const totalPages = Math.ceil(items.length / itemsPerPage);
  const [start, end] = getRangeAround(currentPage, 0, totalPages, numOfPages);

  console.log(hasMore);

  return (
    <div {...props} className={cx(styles.container, props.className)}>
      <Button
        icon={{ element: RiArrowLeftLine, placement: 'left' }}
        onClick={() => onPageChange?.(currentPage - 1, totalPages)}
        disabled={currentPage <= 0}
        className={styles.btn}
        variant="ghost"
      >
        Prev
      </Button>
      {range(start, end + 1).map((i) => {
        const isLast = i === end;
        const isActive = currentPage === i;
        return (
          <Button
            className={cx(isActive && styles.active, styles.btn)}
            onClick={() => onPageChange?.(i, totalPages)}
            aria-disabled={isActive}
            variant={isActive ? 'solid' : 'ghost'}
            key={i}
          >
            {i + 1}
            {isLast && hasMore && '...'}
          </Button>
        );
      })}
      <Button
        icon={{ element: RiArrowRightLine, placement: 'right' }}
        disabled={currentPage >= totalPages - 1}
        onClick={() => onPageChange?.(currentPage + 1, totalPages)}
        className={styles.btn}
        variant="ghost"
      >
        Next
      </Button>
    </div>
  );
}

export default Pagination;
